import { PubSub } from '@instinet-analytics/core-lib';

export interface BarMouseOverState {
    bar?: 'hist' | 'today';
    key?: string;
}

export class BarMouseOver extends PubSub<BarMouseOverState> {}
